enum SlideoutState {
  VIEW_PROGRESS_NOTES = 'VIEW_PROGRESS_NOTES',
  ADD_PROGRESS_NOTE = 'ADD_PROGRESS_NOTE',
  EDIT_PROGRESS_NOTES = 'EDIT_PROGRESS_NOTE',
  PREVIOUS_RESPONSES = 'PREVIOUS_RESPONSES',
}

export default SlideoutState;
